import React from "react";
import {
  Input,
  Label,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
} from "reactstrap";
import logoLight from "../../assets/images/LOGO_LUJ.png";

interface LoginFormProps {
  validation: any;
  passwordShow: boolean;
  setPasswordShow: (show: boolean) => void;
  loader: boolean;
  error: string | null;
}

const LoginForm: React.FC<LoginFormProps> = ({
  validation,
  passwordShow,
  setPasswordShow,
  loader,
  error,
}) => {
  return (
    <>
      <div className="text-center mt-2">
        <h5 className="text-black">Sign in to continue.</h5>
      </div>
      {error && <Alert color="danger">{error}</Alert>}
      <div className="p-2 mt-4">
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <div className="mb-3">
            <Label htmlFor="username" className="form-label">
              Username
            </Label>
            <Input
              name="username"
              className="form-control"
              placeholder="username"
              type="text"
              autoFocus
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.username || ""}
              invalid={
                validation.touched.username && validation.errors.username
                  ? true
                  : false
              }
            />
            {validation.touched.username && validation.errors.username ? (
              <FormFeedback type="invalid">
                {validation.errors.username}
              </FormFeedback>
            ) : null}
          </div>

          <div className="mb-3">
            <Label className="form-label" htmlFor="password-input">
              Password
            </Label>
            <div className="position-relative auth-pass-inputgroup mb-3">
              <Input
                name="password"
                value={validation.values.password || ""}
                type={passwordShow ? "text" : "password"}
                className="form-control pe-5"
                placeholder="Enter Password"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                invalid={
                  validation.touched.password && validation.errors.password
                    ? true
                    : false
                }
              />
              {validation.touched.password && validation.errors.password ? (
                <FormFeedback type="invalid">
                  {validation.errors.password}
                </FormFeedback>
              ) : null}
              <button
                className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                type="button"
                tabIndex={-1}
                id="password-addon"
                onClick={() => setPasswordShow(!passwordShow)}
              >
                <i className="ri-eye-fill align-middle"></i>
              </button>
            </div>
          </div>

          <div className="mt-4">
            <Button
              color="danger"
              disabled={loader}
              className="btn btn-primary w-100"
              type="submit"
            >
              {loader && (
                <Spinner size="sm" className="me-2">
                  Loading...
                </Spinner>
              )}
              Sign In
            </Button>
          </div>

          <div className="mt-4 text-center">
            <div>
              <img src={logoLight} height="80" alt="Logo" />
            </div>
          </div>
        </Form>
      </div>
    </>
  );
};

export default LoginForm;
